/**
 * PasswordGate — demo password prompt.
 *
 * This is a client-side gate for the slam-mlb demo only. It is NOT
 * authentication: the password is shipped in the bundle. Anyone with
 * devtools can bypass it. The gate exists to keep the public demo URL
 * from being crawled or shared with a casual viewer, nothing more.
 */

import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const STORAGE_KEY = 'slam-mlb-demo-gate';
const DEMO_PASSWORD = 'slamsports';
const SLAM_LOGO = `${process.env.PUBLIC_URL || ''}/slam-logo.png`;

export default function PasswordGate() {
  const [unlocked, setUnlocked] = useState(() => {
    try {
      return window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });
  const [input, setInput] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!unlocked) return;
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore — gate already held for this session via state
    }
  }, [unlocked]);

  if (unlocked) return <Outlet />;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (input === DEMO_PASSWORD) {
      setUnlocked(true);
    } else {
      setError('Incorrect password.');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#10141a',
        color: '#dfe2eb',
        fontFamily: 'Inter, sans-serif',
        padding: '24px',
      }}
    >
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: 360,
          padding: '32px',
          background: 'rgba(255, 255, 255, 0.03)',
          border: '1px solid rgba(254, 214, 3, 0.25)',
          borderRadius: 12,
          boxShadow: '0 0 28px rgba(0, 241, 255, 0.08)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <img
            src={SLAM_LOGO}
            alt="SLAM"
            style={{ width: 56, height: 'auto', marginBottom: 12 }}
          />
          <div style={{ fontSize: '1.25rem', fontWeight: 700, letterSpacing: '0.08em' }}>
            SLAM SPORTS AI
          </div>
          <div style={{ fontSize: '0.8125rem', opacity: 0.6, marginTop: 4 }}>
            MLB Demo Platform
          </div>
        </div>

        <label
          htmlFor="demo-password"
          style={{
            display: 'block',
            fontSize: '0.75rem',
            letterSpacing: '0.08em',
            opacity: 0.7,
            marginBottom: 8,
            textTransform: 'uppercase',
          }}
        >
          Password
        </label>
        <input
          id="demo-password"
          type="password"
          autoFocus
          autoComplete="current-password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(''); }}
          style={{
            width: '100%',
            padding: '10px 12px',
            borderRadius: 8,
            background: 'rgba(0, 0, 0, 0.35)',
            border: '1px solid rgba(255, 255, 255, 0.12)',
            color: '#dfe2eb',
            fontSize: '1rem',
            outline: 'none',
            boxSizing: 'border-box',
          }}
        />

        {error && (
          <div
            role="alert"
            style={{
              marginTop: 12,
              fontSize: '0.8125rem',
              color: '#ff8a8a',
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          style={{
            marginTop: 20,
            width: '100%',
            padding: '10px 16px',
            borderRadius: 8,
            border: 'none',
            background: '#FED603',
            color: '#10141a',
            fontWeight: 700,
            letterSpacing: '0.05em',
            cursor: 'pointer',
            fontSize: '0.9375rem',
          }}
        >
          ENTER
        </button>
      </form>
    </div>
  );
}
